<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="layout--main"
    :class="[navbarClasses, footerClasses, { 'app-page': isAppPage }]">

    <custom-sidebar
      ref="sidebar"
      class="sb"
      :class="{ 'sb-force-open': sidebarStatus }"></custom-sidebar>

    <div
      id="content-area"
      :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay"></div>

      <div class="content-wrapper">
        <the-navbar
          :navbarColor="navbarColor"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
          v-if="!$route.meta.hideNavbar" />

        <div class="router-view">
          <div
            class="router-content"
            :class="{
              'mt-0': navbarType == 'hidden' || $route.meta.hideNavbar,
            }">
            <div class="content-area__content">
              <back-to-top
                bottom="5%"
                visibleoffset="500"
                v-if="!hideScrollToTop">
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg" />
              </back-to-top>
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
import VxSidebar from '@/layouts/components/vx-sidebar/VxSidebar.vue';
import TheNavbar from '../components/TheNavbar.vue';
import TheFooter from '../components/TheFooter.vue';
import themeConfig from '@/../themeConfig.js';
import defaultSidebarItems from '@/layouts/components/vx-sidebar/sidebarItems.js';
import CustomSidebar from '@/layouts/components/vx-sidebar/CustomSidebar.vue';

import BackToTop from 'vue-backtotop';
import { mapGetters } from 'vuex';

export default {
  components: {
    VxSidebar,
    TheNavbar,
    TheFooter,
    BackToTop,
    CustomSidebar,
  },
  data() {
    return {
      debugConsole: false,
      navbarType: themeConfig.navbarType || 'floating',
      navbarColor: themeConfig.navbarColor || '#fff',
      footerType: themeConfig.footerType || 'static',
      routerTransition: themeConfig.routerTransition || 'none',
      isNavbarDark: false,
      routeTitle: this.$route.meta.pageTitle,
      // sidebarItems: sidebarItems,
      disableCustomizer: themeConfig.disableCustomizer,
      windowWidth: window.innerWidth, //width of windows
      hideScrollToTop: themeConfig.hideScrollToTop,
      disableThemeTour: themeConfig.disableThemeTour,
      sidebarItemsList: [...defaultSidebarItems],
    };
  },

  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;

      // console.debug('$route change detected', this.$route.params.apiId);
      // if (this.$route.params.apiId !== null)
      //   this.$store.commit('SET_ACTIVE_ACCOUNT', this.$route.params.apiId);

      // console.debug(' ----- Refreshing sidebar accounts! ----- ');
      let items = [...this.sidebarItemsList]; // [...defaultSidebarItems];
      if (this.debugConsole) console.debug('Items before:', items);
      this.updateSidebarAccounts(items);
      this.updateSidebarAccountItems(items);
      if (this.debugConsole) console.debug('Items after:', items);
      this.sidebarItemsList = items;
    },
    isThemeDark(val) {
      if (this.navbarColor === '#fff' && val) {
        this.updateNavbarColor('#10163a');
      } else {
        this.updateNavbarColor('#fff');
      }
    },
  },
  computed: {
    ...mapGetters(['activeAccountGetter']),

    sidebarStatus() {
      return this.$store.state.isSidebarActive;
    },

    sidebarItems() {
      let items = [...this.sidebarItemsList]; // [...defaultSidebarItems];

      this.updateSidebarAccounts(items);
      this.updateSidebarAccountItems(items);

      return items;
    },
    isAppPage() {
      if (this.$route.path.includes('/apps/')) {
        return true;
      } else {
        return false;
      }
    },
    isThemeDark() {
      return this.$store.state.theme == 'dark';
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth === 'default') {
        return 'content-area-default';
      } else if (this.sidebarWidth === 'reduced') {
        return 'content-area-reduced';
      } else if (this.sidebarWidth) return 'content-area-full';
    },
    navbarClasses() {
      return {
        'navbar-hidden': this.navbarType === 'hidden',
        'navbar-sticky': this.navbarType === 'sticky',
        'navbar-static': this.navbarType === 'static',
        'navbar-floating': this.navbarType === 'floating',
      };
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static',
      };
    },
  },
  mounted() {
    // this.$store.state.bodyOverlay = false;
  },
  methods: {
    updateSidebarAccountItems(items) {
      // Disable menu items that require an active account.

      let activeAccount = this.activeAccountGetter;

      if (this.debugConsole)
        console.debug(
          'updateSidebarAccountItems() Active account is ',
          activeAccount ? activeAccount : 'MISSING'
        );

      if (activeAccount) {
        if (this.debugConsole) console.warn('situation b');
        for (let i = 0; i < items.length; ++i) {
          if (items[i].meta && items[i].meta.type === 'when-active-account') {
            items[i].isDisabled = false;
          }
        }
      } else {
        if (this.debugConsole) console.warn('situation c');
        for (let i = 0; i < items.length; ++i) {
          if (items[i].meta && items[i].meta.type === 'when-active-account') {
            items[i].isDisabled = true;
          }
        }
      }

      return items;
    },
    updateSidebarAccounts(items) {
      if (this.debugConsole) console.debug('updateSidebarAccounts()');

      let accounts = this.$store.state.accounts;
      let mainItem;
      let activeAccount = this.activeAccountGetter;
      let accountRedirectRoute = 'dashboard';

      if (this.debugConsole)
        console.debug(
          'updateSidebarAccounts(): active account is ',
          activeAccount
        );
      if (this.debugConsole)
        console.debug(
          'updateSidebarAccounts(): accounts available: ',
          accounts
        );

      if (!activeAccount) {
        if (this.debugConsole)
          console.debug('updateSidebarAccounts(): active account is MISSING.');

        mainItem = {
          url: '/add-account',
          name: 'Add wallet',
          slug: 'add-account',
          i18n: 'Add wallet',
          meta: {
            type: 'account-menu',
            apiId: '',
            settlementType: '',
          },
          submenu: (accounts || [])
            .filter((account) => !account.active)
            .map((account) => {
              return {
                url: `/${accountRedirectRoute}`,
                name: `${account.name}`,
                slug: `${accountRedirectRoute}-${account.apiId}`,
                meta: {
                  apiId: account.apiId,
                  settlementType: account.settlementType,
                },
              };
            }),
        };
      } else {
        if (this.debugConsole)
          console.debug(
            'updateSidebarAccounts(): active account is ' + activeAccount.apiId
          );
        if (this.debugConsole)
          console.debug(
            'updateSidebarAccounts(): submenu accounts are ' +
            JSON.stringify(
              (accounts || []).map((account) => {
                return {
                  ...account,
                  transactions: null,
                  cleanedTransactions: null,
                };
              }),
              null,
              3
            )
          );

        mainItem = {
          url: `/${accountRedirectRoute}`,
          name: `${activeAccount.name}`,
          slug: `${accountRedirectRoute}-${activeAccount.apiId}`,
          meta: {
            type: 'account-menu',
            apiId: activeAccount.apiId,
            settlementType: activeAccount.settlementType,
          },
          submenu: (accounts || [])
            .filter((account) => !account.active)
            .map((account) => {
              if (this.debugConsole)
                window.console.log(
                  'updateSidebarAccounts(): adding SUBmenu account',
                  account
                );
              return {
                url: `/${accountRedirectRoute}`,
                name: `${account.name}`,
                slug: `${accountRedirectRoute}-${account.apiId}`,
                icon: 'CreditCardIcon',
                meta: {
                  apiId: account.apiId,
                  settlementType: account.settlementType,
                },
              };
            }),
        };
      }

      for (let i = 0; i < items.length; ++i) {
        if (items[i].meta && items[i].meta.type === 'account-menu') {
          if (this.debugConsole)
            window.console.log(
              'updateSidebarAccounts(): adding account menu',
              JSON.stringify(mainItem, null, 3)
            );
          items.splice(i, 1, mainItem);
          break;
        }
      }
    },
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val === '#fff') {
        this.isNavbarDark = false;
      } else {
        this.isNavbarDark = true;
      }
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false);
        this.$store.dispatch('updateSidebarWidth', 'no-sidebar');
        this.disableThemeTour = true;
      } else {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
  },

  created() {
    this.setSidebarWidth();
    if (this.navbarColor == '#fff' && this.isThemeDark) {
      this.updateNavbarColor('#10163a');
    } else {
      this.updateNavbarColor(this.navbarColor);
    }
  },
};
</script>

<style scoped>
.sb {
  display: block;
}

.content-wrapper {
  padding-left: 260px;
  min-height: calc(100% - 50px);
}

@media only screen and (max-width: 1200px) {
  .sb {
    display: none;
  }

  .content-wrapper {
    padding-left: 0px;
  }
}

.sb-force-open {
  display: block;
}

/* #content-overlay {
    position: fixed;

    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    cursor: pointer;
    z-index: -1;
} */
/*
.content-overlay-sidebar-open {
    position: absolute;

    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    cursor: pointer;
    z-index: 10;
} */
</style>
